import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonAPIService } from '../commonAPI.service';
import { ArchiveLite } from '../../shared/models/generic/archive-lite.model';

@Injectable({
  providedIn: 'root',
})
export class ArchivesService extends CommonAPIService {
  deleteForPack(params: { packId: string; archiveId: any }): Observable<void> {
    return this.delete<void>(`v2/packs/${params.packId}/archives/${params.archiveId}`);
  }

  publishForPack(params: { packId: string; archiveId: any }): Observable<void> {
    return this.put<void>(`v2/packs/${params.packId}/archives/${params.archiveId}/publish`, null);
  }

  /**
   * Generates a archive file for a pack.
   *
   * @param params the input params
   * @param params.packId the pack ID
   * @param params.applianceGroup the appliance group for which the binary will be created
   * @returns an observable that will emit the backend response containing the created binary and warnings
   */
  generateForPack(params: { packId: string; applianceGroup: string }): Observable<ArchiveLite> {
    return this.post<ArchiveLite>(`v2/packs/${params.packId}/archives`, null, {
      applianceGroup: params.applianceGroup,
    });
  }

  /**
   * get the list of existing archives for a pack
   *
   * @param params the input parameters
   * @param params.packId the pack ID
   * @returns An observable that will emit the list of archives when the backend will respond
   */
  getListForPack(params: { packId: string }): Observable<ArchiveLite[]> {
    return this.get<ArchiveLite[]>(`packs/${params.packId}/archives`);
  }
}
